import FieldsCollection from "../../fields3/collection/base/fields-collection"
import FieldUser from "../../fields3/generic/user/user"
import FieldMoment from "../../fields3/generic/datetime/moment/moment"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldText from "../../fields3/generic/text/text"
import {GroupedData} from "../../data-structures/group"
import FieldTask from "../../fields3/generic/task/task"
import FieldTimeReportIsBillable from "../../fields3/system/time-report/is-billable/is-billable"
import FieldTimeReportDate from "../../fields3/system/time-report/date/time-report-date"
import FieldProjectPath from "../../fields3/generic/project-path/project-path"
import {ColumnID, SystemColumnType} from "../../gd-modules/manager/columns/types"
import FieldProto from "../../fields3/proto/field-proto"
import FieldCostInternal from "../../fields3/generic/finance/cost/cost-internal"
import FieldCostExternal from "../../fields3/generic/finance/cost/cost-external"
import FieldTimeReportEntity from "../../fields3/system/time-report/entity/time-report-entity"
import FieldTimeReportMinutes from "../../fields3/system/time-report/time-reported/time-reported"
import FieldTimeReportProject from "../../fields3/system/time-report/project/time-report-project"
import FieldTimeReportMessage from "../../fields3/system/time-report/message/message"
import FieldTimeReportTimeOfDay from "../../fields3/system/time-report/time-of-day/time-of-day"
import FieldTimeReportActivityType from "../../fields3/system/time-report/activity-type/activity-type-field"
import FieldTimeReportTitle from "../../fields3/system/time-report/title/time-report-title"
import FieldTimeReportId from "../../fields3/system/time-report/id/time-report-id"
import FieldTimeReportUser from "../../fields3/system/time-report/user/time-report-user"
import FieldTimeReportTaskId from "../../fields3/system/time-report/task-id/time-report-task-id"

const baseConfig = [
    {
        fieldId         : 'userId',
        // type            : FieldType.USER,
        type            : FieldType.TIME_REPORT_USER,
        // label           : 'Reported by user',
        // description     : "Choose the user for whom this report will be submitted. Manager access is required to submit on behalf of another user.",
    },
    {
        fieldId         : 'reportedByUsersIds',
        // type            : FieldType.USER,
        type            : FieldType.TIME_REPORT_USER,
        // label           : 'Reported by user',
        // description     : "Choose the user for whom this report will be submitted. Manager access is required to submit on behalf of another user.",
    },
    {
        fieldId         : 'momentCreated',
        type            : FieldType.MOMENT,
        clearButton     : false
    },

    {
        fieldId         : 'reportedTime',
        type            : FieldType.TIME_REPORT_MINUTES,
        clearButton     : false,
        label           : 'Reported Time (Minutes)'
    },
    {
        fieldId         : 'date',
        type            : FieldType.TIME_REPORT_DATE,
        // type            : FieldType.DATE,
        // maxDate         : moment(),
        // clearButton     : false ,
        // label           : 'Report date',
        // description     : 'Date of Time Report'
    },
    {
        fieldId         : 'message',
        type            : FieldType.TIME_REPORT_MESSAGE,
        label           : 'Comments'
    },
    {
        fieldId         : 'commentTxt',
        type            : FieldType.TIME_REPORT_MESSAGE,
        label           : 'Comment'
    },
    {
        fieldId         : 'taskId',
        type            : FieldType.STRING
    },
    {
        fieldId         : 'meetingId',
        type            : FieldType.STRING
    },
    {
        fieldId         : 'costInternal',
        type            : FieldType.COST_INTERNAL
    },
    {
        fieldId         : 'costExternal',
        type            : FieldType.COST_EXTERNAL
    },
    {
        fieldId         : 'startMoment',
        type            : FieldType.TIME_REPORT_TIME_OF_DAY,
        placeholder     : "Start time",
        label           : "Start / End"
    },
    {
        fieldId         : 'endMoment',
        type            : FieldType.TIME_REPORT_TIME_OF_DAY,
        placeholder     : "End time",
    },
    {
        fieldId         : 'isBillable',
        type            : FieldType.TIME_REPORT_IS_BILLABLE,
        label           : 'Is Billable'
    },
    {
        fieldId         : 'activityType',
        type            : FieldType.TIME_REPORT_ACTIVITY_TYPE,
        label           : 'Activity type'
    },
    {
        fieldId         : 'entity',
        type            : FieldType.TIME_REPORT_ENTITY,
        label           : 'Work item'
    },
    {
        fieldId         : 'title',
        type            : FieldType.TIME_REPORT_TITLE,
    },

    {
        fieldId         : 'id',
        type            : FieldType.TIME_REPORT_ID,
    },

    {
        fieldId         : 'taskShortId',
        type            : FieldType.TIME_REPORT_TASK_ID,
        label           : 'Task ID',
    },

    // used as a reference
    {
        fieldId         : 'task',
        type            : FieldType.TASK,
    },
    {
        fieldId         : 'projectId',
        label           : 'Project',
        type            : FieldType.TIME_REPORT_PROJECT,
        maxParents      : 3
    },
    {
        fieldId         : 'projectPath',
        label           : 'Project full path',
        type            : FieldType.PROJECT_PATH,
        maxParents      : 3
    },
]

export default class TimeReportFields extends FieldsCollection {

    // Quick access

    get userId()                : FieldTimeReportUser { return this.get('userId') as FieldTimeReportUser }
    get reportedByUsersIds()    : FieldTimeReportUser { return this.get('reportedByUsersIds') as FieldTimeReportUser }
    get momentCreated()         : FieldMoment { return this.get('momentCreated') as FieldMoment}
    get date()                  : FieldTimeReportDate { return this.get('date') as FieldTimeReportDate }
    get reportedTime()          : FieldTimeReportMinutes /*FieldTaskTimeReported*/ { return this.get('reportedTime') as FieldTimeReportMinutes}
    get commentTxt()            : FieldTimeReportMessage { return this.get('commentTxt') as FieldTimeReportMessage }
    get message()               : FieldTimeReportMessage { return this.get('message') as FieldTimeReportMessage }
    get taskId()                : FieldText { return this.get('taskId') as FieldText }
    get meetingId()             : FieldText { return this.get('meetingId') as FieldText }
    get costInternal()          : FieldCostInternal { return this.get('costInternal') as FieldCostInternal }
    get costExternal()          : FieldCostExternal { return this.get('costExternal') as FieldCostExternal }
    get startMoment()           : FieldTimeReportTimeOfDay{ return this.get('startMoment') as FieldTimeReportTimeOfDay }
    get endMoment()             : FieldTimeReportTimeOfDay{ return this.get('endMoment') as FieldTimeReportTimeOfDay }
    get task()                  : FieldTask{ return this.get('task') as FieldTask }
    get project()               : FieldTimeReportProject { return this.get('projectId') as FieldTimeReportProject }
    get projectPath()           : FieldProjectPath { return this.get('projectPath') as FieldProjectPath }
    get isBillable()            : FieldTimeReportIsBillable{ return this.get('isBillable') as FieldTimeReportIsBillable }
    get entity()                : FieldTimeReportEntity { return this.get('entity') as FieldTimeReportEntity }
    get activityType()          : FieldTimeReportActivityType { return this.get('activityType') as FieldTimeReportActivityType }
    get title()                 : FieldTimeReportTitle { return this.get('title') as FieldTimeReportTitle }
    get id()                    : FieldTimeReportId { return this.get('id') as FieldTimeReportId }
    get taskShortId()           : FieldTimeReportTaskId { return this.get('taskShortId') as FieldTimeReportTaskId }

    constructor() {
        super(baseConfig, EntityType.TIME_REPORT);
    }

    getByColumnId(columnId: ColumnID): FieldProto | undefined {

        const TimeReportFieldsColumnToFieldMap: Partial<Record<SystemColumnType, FieldProto | undefined>> = {

            [SystemColumnType.COMMENTS]             : this.commentTxt,
            [SystemColumnType.TIME_REPORTED]        : this.reportedTime,
            [SystemColumnType.START_DATE]           : this.startMoment,
            [SystemColumnType.END_DATE]             : this.endMoment,
            [SystemColumnType.START_END_MOMENT]     : this.startMoment,
            // [SystemColumnType.END_MOMENT]           : this.endMoment,
            // [SystemColumnType.IS_BILLABLE]          : this.isBillable,
            [SystemColumnType.COST_INTERNAL]        : this.costInternal,
            [SystemColumnType.DATE_CREATED]         : this.momentCreated,
            [SystemColumnType.PROJECT]              : this.project,
            [SystemColumnType.PROJECT_PATH]         : this.projectPath,

            [SystemColumnType.COST_EXTERNAL]        : this.costExternal,
            [SystemColumnType.REPORTED_BY]          : this.reportedByUsersIds,
            [SystemColumnType.REPORT_DATE]          : this.date,
            [SystemColumnType.REPORT_IS_BILLABLE]   : this.isBillable,
            [SystemColumnType.REPORT_MESSAGE]       : this.message,
            [SystemColumnType.REPORT_WORK_ITEM]     : this.entity,
            [SystemColumnType.TITLE]                : this.title,
            [SystemColumnType.REPORT_ID]            : this.id,
            [SystemColumnType.TASK_ID]              : this.taskShortId,
        }

        return TimeReportFieldsColumnToFieldMap[columnId as SystemColumnType]
    }

    get structureConditions():GroupedData {

        // this.initAllCustomFields()
        //
        // const customFields : FieldProto[] = this.customFields()

        return [
            {
                value   : 'time-report',
                label   : 'Time report',
                type    : 'system',
                items   : [
                    gd.fields.timeReport.date,
                    gd.fields.timeReport.userId,
                ]
            },
        ]
    }

    structureFilterFields(customFields?: any[]): GroupedData {
        return [
            {
                value   : 'general',
                label   : 'General',
                type    : 'system',
                items   : [
                    // this.name,
                    this.date,
                    this.reportedByUsersIds,
                    this.isBillable,
                    this.reportedTime,
                    this.message
                ]
            },
            // {
            //     value   : 'timeAndProgress',
            //     label   : 'Time & Progress',
            //     type    : 'system',
            //     items   : [
            //         this.reportedTimeMinutes,
            //         // this.spentEstimate
            //     ]
            // },
            {
                value   : 'finance',
                label   : 'Finance',
                type    : 'system',
                items   : [
                    this.costInternal,
                    this.costExternal
                ]
            },
        ]
    }

    structureForGrouping(excludeFieldIds?: ID[]):GroupedData {

        const filterItems = (items: (FieldProto | string)[]) => {
            return _.filter(items, (item: FieldProto | string) => {
                return typeof item === 'string'
                    || !excludeFieldIds
                    || !excludeFieldIds.includes(item.fieldId)
            })
        }

        return [
            {
                value   : 'time-report',
                label   : 'Time report',
                type    : 'system',
                items   : filterItems([
                    gd.fields.timeReport.date,
                    gd.fields.timeReport.reportedByUsersIds,
                    gd.fields.timeReport.entity,
                    gd.fields.timeReport.project,
                ])
            }
        ]
    }
}
